import axios from 'axios';

import { getBackendBaseUrl } from '@/api/backendAuth';
import type { PaddleCheckoutPlan } from '@/models/PaddleCheckoutPlan';

/** Same host as dashboard + `client-token` — not the registration admin gateway (may not route Paddle). */
export async function fetchPaddleCheckoutPlans(): Promise<PaddleCheckoutPlan[]> {
  const base = getBackendBaseUrl();
  const { data } = await axios.get<PaddleCheckoutPlan[]>(`${base}/billing/paddle/plans`);
  return Array.isArray(data) ? data : [];
}
